/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DashboardCreatePartner,
  DashboardPartner,
  DashboardPartnersControllerCreate400,
  DashboardPartnersControllerCreate401,
  DashboardPartnersControllerCreate429,
  DashboardPartnersControllerDetail400,
  DashboardPartnersControllerDetail401,
  DashboardPartnersControllerDetail404,
  DashboardPartnersControllerDetail429,
  DashboardPartnersControllerList400,
  DashboardPartnersControllerList401,
  DashboardPartnersControllerList429,
  DashboardPartnersControllerListParams,
  DashboardPartnersControllerRemove400,
  DashboardPartnersControllerRemove401,
  DashboardPartnersControllerRemove404,
  DashboardPartnersControllerRemove429,
  DashboardPartnersControllerReorder400,
  DashboardPartnersControllerReorder401,
  DashboardPartnersControllerReorder404,
  DashboardPartnersControllerReorder429,
  DashboardPartnersControllerUpdate400,
  DashboardPartnersControllerUpdate401,
  DashboardPartnersControllerUpdate404,
  DashboardPartnersControllerUpdate429,
  DashboardReorderPartners,
  DashboardUpdatePartner,
} from ".././schemas";
import { restClient } from "../../restClient";
import type { ErrorType, BodyType } from "../../restClient";

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Partners for a single owner scope, ordered by `sortingPosition` (ascending, nulls last). Supply exactly one owner filter — `platformIds` (`plt_…`) OR `federationIds` (`fed_…`) OR `leagueIds` (`lge_…`), each with a single public id. Not paginated: the full ordered list is returned so it can be drag-reordered client-side.
 * @summary List partners (dashboard)
 */
export const dashboardPartnersControllerList = (
  params?: DashboardPartnersControllerListParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardPartner[]>(
    { url: `/api/dashboard/v1/partners`, method: "GET", params, signal },
    options
  );
};

export const getDashboardPartnersControllerListQueryKey = (
  params?: DashboardPartnersControllerListParams
) => {
  return [`/api/dashboard/v1/partners`, ...(params ? [params] : [])] as const;
};

export const getDashboardPartnersControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardPartnersControllerList>>,
  TError = ErrorType<
    | DashboardPartnersControllerList400
    | DashboardPartnersControllerList401
    | DashboardPartnersControllerList429
  >,
>(
  params?: DashboardPartnersControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPartnersControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardPartnersControllerListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardPartnersControllerList>>> = ({
    signal,
  }) => dashboardPartnersControllerList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardPartnersControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardPartnersControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPartnersControllerList>>
>;
export type DashboardPartnersControllerListQueryError = ErrorType<
  | DashboardPartnersControllerList400
  | DashboardPartnersControllerList401
  | DashboardPartnersControllerList429
>;

export function useDashboardPartnersControllerList<
  TData = Awaited<ReturnType<typeof dashboardPartnersControllerList>>,
  TError = ErrorType<
    | DashboardPartnersControllerList400
    | DashboardPartnersControllerList401
    | DashboardPartnersControllerList429
  >,
>(
  params: undefined | DashboardPartnersControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPartnersControllerList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPartnersControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPartnersControllerList<
  TData = Awaited<ReturnType<typeof dashboardPartnersControllerList>>,
  TError = ErrorType<
    | DashboardPartnersControllerList400
    | DashboardPartnersControllerList401
    | DashboardPartnersControllerList429
  >,
>(
  params?: DashboardPartnersControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPartnersControllerList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPartnersControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPartnersControllerList<
  TData = Awaited<ReturnType<typeof dashboardPartnersControllerList>>,
  TError = ErrorType<
    | DashboardPartnersControllerList400
    | DashboardPartnersControllerList401
    | DashboardPartnersControllerList429
  >,
>(
  params?: DashboardPartnersControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPartnersControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List partners (dashboard)
 */

export function useDashboardPartnersControllerList<
  TData = Awaited<ReturnType<typeof dashboardPartnersControllerList>>,
  TError = ErrorType<
    | DashboardPartnersControllerList400
    | DashboardPartnersControllerList401
    | DashboardPartnersControllerList429
  >,
>(
  params?: DashboardPartnersControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPartnersControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardPartnersControllerListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a partner attached to exactly one owner (`platformId` / `federationId` / `leagueId`). Returns the created partner.
 * @summary Create partner (dashboard)
 */
export const dashboardPartnersControllerCreate = (
  dashboardCreatePartner: BodyType<DashboardCreatePartner>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardPartner>(
    {
      url: `/api/dashboard/v1/partners`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardCreatePartner,
      signal,
    },
    options
  );
};

export const getDashboardPartnersControllerCreateMutationOptions = <
  TError = ErrorType<
    | DashboardPartnersControllerCreate400
    | DashboardPartnersControllerCreate401
    | DashboardPartnersControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPartnersControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreatePartner> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardPartnersControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreatePartner> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardPartnersControllerCreate>>,
    { data: BodyType<DashboardCreatePartner> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardPartnersControllerCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardPartnersControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPartnersControllerCreate>>
>;
export type DashboardPartnersControllerCreateMutationBody = BodyType<DashboardCreatePartner>;
export type DashboardPartnersControllerCreateMutationError = ErrorType<
  | DashboardPartnersControllerCreate400
  | DashboardPartnersControllerCreate401
  | DashboardPartnersControllerCreate429
>;

/**
 * @summary Create partner (dashboard)
 */
export const useDashboardPartnersControllerCreate = <
  TError = ErrorType<
    | DashboardPartnersControllerCreate400
    | DashboardPartnersControllerCreate401
    | DashboardPartnersControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPartnersControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreatePartner> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardPartnersControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreatePartner> },
  TContext
> => {
  const mutationOptions = getDashboardPartnersControllerCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Full partner detail. 404 when it doesn't exist or is out of the caller's scope.
 * @summary Get partner detail (dashboard)
 */
export const dashboardPartnersControllerDetail = (
  id: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardPartner>(
    { url: `/api/dashboard/v1/partners/${id}`, method: "GET", signal },
    options
  );
};

export const getDashboardPartnersControllerDetailQueryKey = (id: string) => {
  return [`/api/dashboard/v1/partners/${id}`] as const;
};

export const getDashboardPartnersControllerDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardPartnersControllerDetail>>,
  TError = ErrorType<
    | DashboardPartnersControllerDetail400
    | DashboardPartnersControllerDetail401
    | DashboardPartnersControllerDetail404
    | DashboardPartnersControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPartnersControllerDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardPartnersControllerDetailQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardPartnersControllerDetail>>> = ({
    signal,
  }) => dashboardPartnersControllerDetail(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardPartnersControllerDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardPartnersControllerDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPartnersControllerDetail>>
>;
export type DashboardPartnersControllerDetailQueryError = ErrorType<
  | DashboardPartnersControllerDetail400
  | DashboardPartnersControllerDetail401
  | DashboardPartnersControllerDetail404
  | DashboardPartnersControllerDetail429
>;

export function useDashboardPartnersControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardPartnersControllerDetail>>,
  TError = ErrorType<
    | DashboardPartnersControllerDetail400
    | DashboardPartnersControllerDetail401
    | DashboardPartnersControllerDetail404
    | DashboardPartnersControllerDetail429
  >,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPartnersControllerDetail>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPartnersControllerDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPartnersControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardPartnersControllerDetail>>,
  TError = ErrorType<
    | DashboardPartnersControllerDetail400
    | DashboardPartnersControllerDetail401
    | DashboardPartnersControllerDetail404
    | DashboardPartnersControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPartnersControllerDetail>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPartnersControllerDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPartnersControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardPartnersControllerDetail>>,
  TError = ErrorType<
    | DashboardPartnersControllerDetail400
    | DashboardPartnersControllerDetail401
    | DashboardPartnersControllerDetail404
    | DashboardPartnersControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPartnersControllerDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get partner detail (dashboard)
 */

export function useDashboardPartnersControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardPartnersControllerDetail>>,
  TError = ErrorType<
    | DashboardPartnersControllerDetail400
    | DashboardPartnersControllerDetail401
    | DashboardPartnersControllerDetail404
    | DashboardPartnersControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardPartnersControllerDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardPartnersControllerDetailQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Partial update. The owner attachment cannot be changed here. 404 when the partner is out of the caller's scope.
 * @summary Update partner (dashboard)
 */
export const dashboardPartnersControllerUpdate = (
  id: string,
  dashboardUpdatePartner: BodyType<DashboardUpdatePartner>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<DashboardPartner>(
    {
      url: `/api/dashboard/v1/partners/${id}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardUpdatePartner,
    },
    options
  );
};

export const getDashboardPartnersControllerUpdateMutationOptions = <
  TError = ErrorType<
    | DashboardPartnersControllerUpdate400
    | DashboardPartnersControllerUpdate401
    | DashboardPartnersControllerUpdate404
    | DashboardPartnersControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPartnersControllerUpdate>>,
    TError,
    { id: string; data: BodyType<DashboardUpdatePartner> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardPartnersControllerUpdate>>,
  TError,
  { id: string; data: BodyType<DashboardUpdatePartner> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardPartnersControllerUpdate>>,
    { id: string; data: BodyType<DashboardUpdatePartner> }
  > = (props) => {
    const { id, data } = props ?? {};

    return dashboardPartnersControllerUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardPartnersControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPartnersControllerUpdate>>
>;
export type DashboardPartnersControllerUpdateMutationBody = BodyType<DashboardUpdatePartner>;
export type DashboardPartnersControllerUpdateMutationError = ErrorType<
  | DashboardPartnersControllerUpdate400
  | DashboardPartnersControllerUpdate401
  | DashboardPartnersControllerUpdate404
  | DashboardPartnersControllerUpdate429
>;

/**
 * @summary Update partner (dashboard)
 */
export const useDashboardPartnersControllerUpdate = <
  TError = ErrorType<
    | DashboardPartnersControllerUpdate400
    | DashboardPartnersControllerUpdate401
    | DashboardPartnersControllerUpdate404
    | DashboardPartnersControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPartnersControllerUpdate>>,
    TError,
    { id: string; data: BodyType<DashboardUpdatePartner> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardPartnersControllerUpdate>>,
  TError,
  { id: string; data: BodyType<DashboardUpdatePartner> },
  TContext
> => {
  const mutationOptions = getDashboardPartnersControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Remove a partner. 404 when it's out of the caller's scope.
 * @summary Delete partner (dashboard)
 */
export const dashboardPartnersControllerRemove = (
  id: string,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<void>({ url: `/api/dashboard/v1/partners/${id}`, method: "DELETE" }, options);
};

export const getDashboardPartnersControllerRemoveMutationOptions = <
  TError = ErrorType<
    | DashboardPartnersControllerRemove400
    | DashboardPartnersControllerRemove401
    | DashboardPartnersControllerRemove404
    | DashboardPartnersControllerRemove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPartnersControllerRemove>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardPartnersControllerRemove>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardPartnersControllerRemove>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return dashboardPartnersControllerRemove(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardPartnersControllerRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPartnersControllerRemove>>
>;

export type DashboardPartnersControllerRemoveMutationError = ErrorType<
  | DashboardPartnersControllerRemove400
  | DashboardPartnersControllerRemove401
  | DashboardPartnersControllerRemove404
  | DashboardPartnersControllerRemove429
>;

/**
 * @summary Delete partner (dashboard)
 */
export const useDashboardPartnersControllerRemove = <
  TError = ErrorType<
    | DashboardPartnersControllerRemove400
    | DashboardPartnersControllerRemove401
    | DashboardPartnersControllerRemove404
    | DashboardPartnersControllerRemove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPartnersControllerRemove>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardPartnersControllerRemove>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDashboardPartnersControllerRemoveMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Bulk-update `sortingPosition` for a set of partners, each identified by its `prt_…` public id (a legacy numeric id is still accepted during the transition). Every partner must be within the caller's scope. Returns the reordered partners.
 * @summary Reorder partners (dashboard)
 */
export const dashboardPartnersControllerReorder = (
  dashboardReorderPartners: BodyType<DashboardReorderPartners>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<DashboardPartner[]>(
    {
      url: `/api/dashboard/v1/partners/reorder`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardReorderPartners,
    },
    options
  );
};

export const getDashboardPartnersControllerReorderMutationOptions = <
  TError = ErrorType<
    | DashboardPartnersControllerReorder400
    | DashboardPartnersControllerReorder401
    | DashboardPartnersControllerReorder404
    | DashboardPartnersControllerReorder429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPartnersControllerReorder>>,
    TError,
    { data: BodyType<DashboardReorderPartners> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardPartnersControllerReorder>>,
  TError,
  { data: BodyType<DashboardReorderPartners> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardPartnersControllerReorder>>,
    { data: BodyType<DashboardReorderPartners> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardPartnersControllerReorder(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardPartnersControllerReorderMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPartnersControllerReorder>>
>;
export type DashboardPartnersControllerReorderMutationBody = BodyType<DashboardReorderPartners>;
export type DashboardPartnersControllerReorderMutationError = ErrorType<
  | DashboardPartnersControllerReorder400
  | DashboardPartnersControllerReorder401
  | DashboardPartnersControllerReorder404
  | DashboardPartnersControllerReorder429
>;

/**
 * @summary Reorder partners (dashboard)
 */
export const useDashboardPartnersControllerReorder = <
  TError = ErrorType<
    | DashboardPartnersControllerReorder400
    | DashboardPartnersControllerReorder401
    | DashboardPartnersControllerReorder404
    | DashboardPartnersControllerReorder429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPartnersControllerReorder>>,
    TError,
    { data: BodyType<DashboardReorderPartners> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardPartnersControllerReorder>>,
  TError,
  { data: BodyType<DashboardReorderPartners> },
  TContext
> => {
  const mutationOptions = getDashboardPartnersControllerReorderMutationOptions(options);

  return useMutation(mutationOptions);
};
